module.exports = __webpack_public_path__ + "img/general-meter-electricity-meter-digital-lg.f6080ed9.svg";